/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";

import { MdWidgets } from "react-icons/md";
import { GoSignOut } from "react-icons/go";
import { BsPeopleFill, BsCheckCircle } from "react-icons/bs";
import { TiFlowMerge, TiFlowChildren } from "react-icons/ti";
import { IoPeopleCircleOutline } from "react-icons/io5";
import { RiWhatsappLine } from "react-icons/ri";
import { MdAccountBalance } from "react-icons/md";

import { SideItem, SideLogo, SideMain } from "./styles";
import logo from "../../assets/sidebar-icon.svg";
import logoFull from "../../assets/spread-eloz-icon.png";
import { Auth } from "../../services/Auth";
import { SectorContext } from "../../context/sectorFilter";
import { Link } from "react-router-dom";
import { FaUserLock } from "react-icons/fa";

function Sidebar({ activeMenu }) {
	const { push } = useHistory();
	const [logoS, setLogoS] = useState(logo);
	const menuRef = useRef(null);

	//sector context
	const { configFilter } = useContext(SectorContext);

	useEffect(() => {
		if (!activeMenu) {
			return;
		}
		if (menuRef.current) {
			const children = [...menuRef.current.children];
			const datasets = children.filter(
				(el) => el.dataset.tooltip === activeMenu,
			);
			datasets[0]?.classList?.add("active-menu-item");
		}
	}, []);

	return (
		<SideMain
			onMouseEnter={() => setLogoS(logoFull)}
			onMouseLeave={() => setLogoS(logo)}
		>
			<ul ref={menuRef}>
				<SideLogo
					onClick={() => {
						localStorage.setItem("active-page", "dashboard");
						push("/dashboard");
					}}
				>
					<img src={logoS} alt="spread.chat" />
				</SideLogo>

				<SideItem
					data-tooltip="accounts"
					onClick={() => {
						localStorage.setItem("active-page", "accounts");
					}}
				>
					<Link to="/accounts">
						<MdAccountBalance size={25} />
						<span>Clientes</span>
					</Link>
				</SideItem>

				<SideItem
					data-tooltip="operators"
					onClick={() => {
						localStorage.setItem("active-page", "operators");
					}}
				>
					<Link to="/operators">
						<IoPeopleCircleOutline size={25} />
						<span>Atendentes</span>
					</Link>
				</SideItem>

				<SideItem
					data-tooltip="managers"
					onClick={() => {
						localStorage.setItem("active-page", "managers");
					}}
				>
					<Link to="/managers">
						<FaUserLock size={25} />
						<span>Gestores</span>
					</Link>
				</SideItem>

				<SideItem
					data-tooltip="sectors"
					onClick={() => {
						configFilter("");
						localStorage.setItem("active-page", "sectors");
					}}
				>
					<Link to="/sectors">
						<BsPeopleFill size={20} />
						<span>Setores</span>
					</Link>
				</SideItem>

				<hr
					style={{
						margin: "5px 0",
						borderTop: "1.5px solid #7d7d7d",
					}}
				/>

				<SideItem
					data-tooltip="landbot"
					onClick={() => {
						configFilter("");
						localStorage.setItem("active-page", "landbotchannel");
					}}
				>
					<Link to="/landbotchannel">
						<TiFlowMerge size={20} />
						<span>Canais Landbot</span>
					</Link>
				</SideItem>

				<SideItem
					data-tooltip="bot-builder"
					onClick={() => {
						configFilter("");
						localStorage.setItem("active-page", "bot-builder");
					}}
				>
					<Link to="/bot-builder">
						<TiFlowChildren size={20} />
						<span>Bot Builder</span>
					</Link>
				</SideItem>

				<hr
					style={{
						margin: "5px 0",
						borderTop: "1.5px solid #7d7d7d",
					}}
				/>

				<SideItem
					data-tooltip="numbersOfficial"
					onClick={() => {
						configFilter("");
						localStorage.setItem("active-page", "numberOfficial");
					}}
				>
					<Link to="/numberOfficial">
						<RiWhatsappLine size={20} />
						<span>Números de Whatsapp</span>
					</Link>
				</SideItem>

				<SideItem
					data-tooltip="checkTemplate"
					onClick={() => {
						configFilter("");
						localStorage.setItem("active-page", "checkTemplate");
					}}
				>
					<Link to="/checkTemplate">
						<BsCheckCircle size={20} />
						<span>Validar templates</span>
					</Link>
				</SideItem>

				<hr
					style={{
						margin: "5px 0",
						borderTop: "1.5px solid #7d7d7d",
					}}
				/>

				<SideItem
					data-tooltip="updates-extension"
					className="logout"
					onClick={() => {
						localStorage.setItem("active-page", "updates-extension");
					}}
				>
					<Link to="/updates-extension">
						<MdWidgets size={20} />
						<span>Versões Extensão</span>
					</Link>
				</SideItem>

				<SideItem
					onClick={() => {
						new Auth().Logout();
					}}
				>
					<GoSignOut size={20} />
					<span>Sair</span>
				</SideItem>
			</ul>
		</SideMain>
	);
}

export default Sidebar;
